import { autoinject, computedFrom, transient, useView } from "aurelia-framework";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { AttachmentClientService } from "../../../../../../services/attachment/attachments-client.service";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipDialogServiceConstants } from "../../../../../../constants/basics/rightship-dialog.constants";
import { IncidentClientModel } from "../../../../../../models/incidents/incident.models";
import { IncidentStatusEnum } from "../../../../../../models/vetting/vetting.models";
import { RightshipEntityAttachmentManager } from "../../../common-steps/rightship-entity-attachment/rightship-entity-attachment-manager";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { BindingSignaler } from "aurelia-templating-resources";
import { QueriesClientService } from "../../../../../../services/queries/queries-client.services";

@autoinject
@transient()
@useView('views/pages/modules/incident/tabs/documents/incident-documents.html')
export class IncidentDocuments extends RightshipEntityAttachmentManager {
    public multiple: boolean = true;
    public accept: string = "application/pdf,image/png,image/jpeg,image/jpg,application/zip,application/x-zip-compressed,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/vnd.ms-outlook,.msg";
    constructor(attachmentClientService: AttachmentClientService, notificationService: NotificationClientService, userClaimsService: UserClaimsService,
        dialogService: DialogClientService, i18N: I18N, queriesClientService: QueriesClientService,
        bindingSignaler: BindingSignaler) {
        super(attachmentClientService, notificationService, userClaimsService, dialogService, i18N, queriesClientService, bindingSignaler);
    }

    public openAttachmentsDialog() {
        this.itemInEdit = null;
        this.dialogService.show(RightShipDialogServiceConstants.URLs.RightshipAttachmentsDialog, this, true, false, false, 'right');
    }

    @computedFrom('rootItem', 'entityId')
    public get canAdd(): boolean {
        return super.canAdd && (this.entityId && this.entityId > 0);
    }

    @computedFrom('rootItem', 'entityId')
    public get canDelete(): boolean {
        return super.canDelete && (this.entityId && this.entityId > 0);
    }

    @computedFrom("currentStatus.statusId")
    public get isMisreported(): boolean {
        return this.rootItem &&
            (<IncidentClientModel>this.rootItem).incidentStatusId == IncidentStatusEnum.Misreported;
    }

    public loadAttachments() {
        return new Promise<void>((resolve, reject) => {
            if (this.isLoadingAttachments || !this.shouldLoadAttachments || (this.rootEntityType == null || this.rootItem == null)) {
                resolve();
                return;
            }
            
            this.isLoadingAttachments = true;

            this.items = [];

            this.queriesClientService.getData('odata/RightShipAttachments/Genesis.GetAttachments(entityTypeId='+this.rootEntityType+',entityId=' + (<any>this.rootItem).id + ')').then(results => {
                this.items = results.value

                for (const override of this.rootItem["incidentOverrides"]) {
                    this.queriesClientService.getData('odata/RightShipAttachments/Genesis.GetAttachments(entityTypeId='+EntityTypes.IncidentOverride+',entityId=' + override + ')').then(results => {
                        this.items = this.items.concat(results.value);
                    }).catch(() => {
                        this.isLoadingAttachments = false;
                        reject();
                    });

                    if (this.onAttachmentsLoaded) {
                        this.onAttachmentsLoaded();
                    }
                    this.isLoadingAttachments = false;
                    resolve();
                }
                
                this.isLoadingAttachments = false;
                resolve();
            }).catch(() => {
                this.isLoadingAttachments = false;
                reject();
            });
        });
    }

}